"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RejectError extends Error {
    constructor(message, data) {
        super(message);
        this.data = data;
    }
}
exports.default = RejectError;
//# sourceMappingURL=RejectError.js.map